// extracted by mini-css-extract-plugin
export default {"CallIcon":"EVebh","default":"rJ97J","circle":"eftzG","phone":"t2-A8","black":"k-E4X"};